import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApi } from '@core/base/base-api';
import { Survey } from '@shared/survey/survey';
import { SurveyAnswer } from '@shared/survey/survey-answer';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SurveyApi extends BaseApi<Survey> {
  constructor(httpClient: HttpClient) {
    super(httpClient, 'questionnaire/surveys');
  }

  create(): Survey {
    return new Survey();
  }

  accept(uuid: string[]): Observable<void> {
    return this.httpClient.post<void>(`${this.endpoint}/accept`, { uuid });
  }

  reject(uuid: string[], comment: string | undefined): Observable<void> {
    return this.httpClient.post<void>(`${this.endpoint}/reject`, {
      uuid,
      comment,
    });
  }

  inprogress(uuid: string[], comment: string | undefined): Observable<void> {
    return this.httpClient.post<void>(`${this.endpoint}/inprogress`, {
      uuid,
      comment,
    });
  }

  findAnswers(uuid: string): Observable<SurveyAnswer[]> {
    return this.httpClient.get<SurveyAnswer[]>(`${this.endpoint}/${uuid}/answers`);
  }

  getRounds(): Observable<string[]> {
    return this.httpClient.get<string[]>(`${this.endpoint}/rounds`);
  }

  uploadSurveys(file: File): Observable<HttpResponse<Blob>> {
    const formData = new FormData();
    formData.append('file', file);

    return this.httpClient.post(`${this.endpoint}/upload`, formData, {
      observe: 'response',
      responseType: 'blob',
    });
  }
}
